/**
 * Product Page Modifications
 * Handles subscription widget price updates and variant selector integration
 */

(function() {
  console.log('[Product Page Mod] Script loaded');

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[Product Page Mod] DOM ready, initializing...');

    // Check for custom variant selector or custom qty selector
    const customVariantSelector = document.querySelector('.custom-variant-selector--container');
    const customQtySelector = document.querySelector('[id^="qty-selector-"]');

    console.log('[Product Page Mod] Detected selectors:', {
      customVariantSelector: !!customVariantSelector,
      customQtySelector: !!customQtySelector
    });

    // Get the radio buttons
    const oneTimeRadio = document.getElementById('purchaseTypeOneTime');
    const subscriptionRadio = document.getElementById('purchaseTypeSubscription');

    console.log('[Product Page Mod] Radio buttons found:', {
      oneTimeRadio: !!oneTimeRadio,
      subscriptionRadio: !!subscriptionRadio
    });

    // Get the price elements to update
    const salePriceElement = document.querySelector('.price-item--sale.price-item--last');
    const regularPriceElement = document.querySelector('.price__sale s.price-item--regular');

    if (!salePriceElement) {
      console.error('[Product Page Mod] Sale price element not found, cannot initialize');
      return;
    }

    // Get actual prices from the DOM
    const originalOneTimePrice = salePriceElement.textContent.trim();
    const originalCompareAtPrice = regularPriceElement ? regularPriceElement.textContent.trim() : originalOneTimePrice;

    // Detect if prices include USD suffix
    const hasUSDSuffix = originalOneTimePrice.includes('USD');

    // Get subscription price from the widget
    // Try multiple selectors to find the subscription price
    let subscriptionPrice = originalOneTimePrice;

    // Method 1: Look for the subscription price in the subscription radio option
    const subscriptionPriceElement = document.querySelector('[data-stayai-subscription-price]');

    if (subscriptionPriceElement) {
      const priceText = subscriptionPriceElement.textContent;
      console.log('[Product Page Mod] Raw subscription price text:', priceText);

      // Extract all prices from the text
      const priceMatches = priceText.match(/\$[\d.,]+(?:\s*USD)?/g);
      console.log('[Product Page Mod] Found price matches:', priceMatches);

      if (priceMatches && priceMatches.length > 0) {
        // If there are multiple prices, the subscription price is typically the last one
        // But we need to filter out the one-time price if it appears
        // Take the lowest price as that's typically the subscription discount
        const prices = priceMatches.map(p => {
          const numericPrice = parseFloat(p.replace(/[$,\s]/g, '').replace('USD', ''));
          return { text: p, value: numericPrice };
        });

        // Sort by value to find the lowest (subscription) price
        prices.sort((a, b) => a.value - b.value);
        subscriptionPrice = prices[0].text;

        // Ensure USD suffix is consistent with original prices
        if (hasUSDSuffix && !subscriptionPrice.includes('USD')) {
          subscriptionPrice = subscriptionPrice + ' USD';
        } else if (!hasUSDSuffix && subscriptionPrice.includes('USD')) {
          subscriptionPrice = subscriptionPrice.replace(/\s*USD/, '');
        }

        console.log('[Product Page Mod] Selected subscription price:', subscriptionPrice, 'from prices:', prices);
      }
    }

    // Method 2: If no subscription element found, try looking in the selling plan options
    if (!subscriptionPriceElement) {
      const sellingPlanPrice = document.querySelector('[data-stayai-selling-plan-price]');
      if (sellingPlanPrice) {
        const priceText = sellingPlanPrice.textContent.trim();
        const priceMatch = priceText.match(/\$[\d.,]+(?:\s*USD)?/);
        if (priceMatch) {
          subscriptionPrice = priceMatch[0];

          // Ensure USD suffix is consistent
          if (hasUSDSuffix && !subscriptionPrice.includes('USD')) {
            subscriptionPrice = subscriptionPrice + ' USD';
          } else if (!hasUSDSuffix && subscriptionPrice.includes('USD')) {
            subscriptionPrice = subscriptionPrice.replace(/\s*USD/, '');
          }

          console.log('[Product Page Mod] Found subscription price from selling plan:', subscriptionPrice);
        }
      }
    }

    // Get the add-to-cart button
    const addToCartButton = document.querySelector('button[name="add"]');
    let originalButtonText = 'Add to cart';

    if (addToCartButton) {
      // Store the original button text (without any price)
      originalButtonText = addToCartButton.textContent.trim().split('•')[0].trim();
      console.log('[Product Page Mod] Add to cart button found, original text:', originalButtonText);
    } else {
      console.warn('[Product Page Mod] Add to cart button not found');
    }

    console.log('[Product Page Mod] Price elements found and extracted:', {
      salePriceElement: !!salePriceElement,
      regularPriceElement: !!regularPriceElement,
      originalOneTimePrice: originalOneTimePrice,
      originalCompareAtPrice: originalCompareAtPrice,
      subscriptionPrice: subscriptionPrice,
      addToCartButton: !!addToCartButton
    });

    // Function to get current variant/qty price
    function getCurrentVariantPrice() {
      // Check custom variant selector first
      if (customVariantSelector) {
        const checkedInput = customVariantSelector.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          const label = customVariantSelector.querySelector(`label[for="${checkedInput.id}"]`);
          if (label) {
            const variantPrice = label.querySelector('.variant-price');
            const variantComparePrice = label.querySelector('.variant-compare-price');

            if (variantPrice) {
              console.log('[Product Page Mod] Found variant prices from custom selector:', {
                price: variantPrice.textContent.trim(),
                comparePrice: variantComparePrice ? variantComparePrice.textContent.trim() : null
              });

              return {
                price: variantPrice.textContent.trim(),
                comparePrice: variantComparePrice ? variantComparePrice.textContent.trim() : null
              };
            }
          }
        }
      }

      // Check custom qty selector
      if (customQtySelector) {
        const checkedQtyInput = document.querySelector('input[name^="qty-selector-"]:checked');
        if (checkedQtyInput) {
          const qtyContainer = checkedQtyInput.closest('.custom-qty-option');
          if (qtyContainer) {
            const priceContainer = qtyContainer.querySelector('.custom-qty-price');
            if (priceContainer) {
              const currentPrice = priceContainer.querySelector('.custom-qty-price-current');
              const comparePrice = priceContainer.querySelector('.custom-qty-price-compare');

              if (currentPrice) {
                console.log('[Product Page Mod] Found qty prices from custom selector:', {
                  price: currentPrice.textContent.trim(),
                  comparePrice: comparePrice ? comparePrice.textContent.trim() : null
                });

                return {
                  price: currentPrice.textContent.trim(),
                  comparePrice: comparePrice ? comparePrice.textContent.trim() : null
                };
              }
            }
          }
        }
      }

      // Return original prices if no custom selector
      return {
        price: originalOneTimePrice,
        comparePrice: originalCompareAtPrice
      };
    }

    // Function to update the price display
    function updatePriceDisplay(isSubscription) {
      console.log('[Product Page Mod] updatePriceDisplay called with isSubscription:', isSubscription);

      if (!salePriceElement) {
        console.warn('[Product Page Mod] Sale price element not found, cannot update');
        return;
      }

      // Get current variant/qty prices
      const currentPrices = getCurrentVariantPrice();
      console.log('[Product Page Mod] Current prices:', currentPrices);

      const oldSalePrice = salePriceElement.textContent;
      const oldRegularPrice = regularPriceElement ? regularPriceElement.textContent : 'N/A';

      if (isSubscription) {
        // Update to subscription price
        salePriceElement.textContent = subscriptionPrice;
        if (regularPriceElement) {
          regularPriceElement.textContent = currentPrices.price;
        }

        console.log('[Product Page Mod] Updated to SUBSCRIPTION pricing:', {
          salePrice: `${oldSalePrice} → ${subscriptionPrice}`,
          regularPrice: `${oldRegularPrice} → ${currentPrices.price}`
        });
      } else {
        // Update to one-time purchase price
        salePriceElement.textContent = currentPrices.price;
        if (regularPriceElement && currentPrices.comparePrice) {
          regularPriceElement.textContent = currentPrices.comparePrice;
        }

        console.log('[Product Page Mod] Updated to ONE-TIME pricing:', {
          salePrice: `${oldSalePrice} → ${currentPrices.price}`,
          regularPrice: `${oldRegularPrice} → ${currentPrices.comparePrice || 'N/A'}`
        });
      }
    }

    // Add event listeners to both radio buttons
    if (oneTimeRadio) {
      console.log('[Product Page Mod] Adding event listener to one-time radio');
      oneTimeRadio.addEventListener('change', function() {
        console.log('[Product Page Mod] One-time radio changed, checked:', this.checked);
        if (this.checked) {
          updatePriceDisplay(false);
        }
      });
    } else {
      console.warn('[Product Page Mod] One-time radio button not found');
    }

    if (subscriptionRadio) {
      console.log('[Product Page Mod] Adding event listener to subscription radio');
      subscriptionRadio.addEventListener('change', function() {
        console.log('[Product Page Mod] Subscription radio changed, checked:', this.checked);
        if (this.checked) {
          updatePriceDisplay(true);
        }
      });
    } else {
      console.warn('[Product Page Mod] Subscription radio button not found');
    }

    // Add event listeners to custom variant selector
    if (customVariantSelector) {
      console.log('[Product Page Mod] Adding event listener to custom variant selector');
      customVariantSelector.addEventListener('change', function(e) {
        if (e.target.type === 'radio') {
          console.log('[Product Page Mod] Variant changed, updating prices');
          // Determine if subscription is currently selected
          const isSubscription = subscriptionRadio && subscriptionRadio.checked;
          updatePriceDisplay(isSubscription);
        }
      });
    }

    // Add event listeners to custom qty selector
    if (customQtySelector) {
      console.log('[Product Page Mod] Adding event listener to custom qty selector');
      const allQtyInputs = document.querySelectorAll('input[name^="qty-selector-"]');
      allQtyInputs.forEach(input => {
        input.addEventListener('change', function() {
          console.log('[Product Page Mod] Qty changed, updating prices');
          // Determine if subscription is currently selected
          const isSubscription = subscriptionRadio && subscriptionRadio.checked;
          updatePriceDisplay(isSubscription);
        });
      });
    }

    // Set initial state based on which radio is currently checked
    if (subscriptionRadio && subscriptionRadio.checked) {
      console.log('[Product Page Mod] Initial state: Subscription is checked');
      updatePriceDisplay(true);
    } else if (oneTimeRadio && oneTimeRadio.checked) {
      console.log('[Product Page Mod] Initial state: One-time is checked');
      updatePriceDisplay(false);
    } else {
      console.log('[Product Page Mod] Initial state: No radio button checked');
    }

    console.log('[Product Page Mod] Initialization complete');
  });
})();
